import '@nsc/otrs/api/index.js';
import '@nsc/nexus-permissions/nexus-api/platform-gated-reads.js';
import '@nsc/nexus-permissions/subscribe-all-roles.js';
import '@nsc/whitelist/api/subscribe-whitelist-entries.js';
import './nexus-entity-list-subscriptions.js';
import './nexus-gated-paginated.js';
import './nexus-scoped-clients.js';
import './nexus-invite-email.js';
import './nexus-user-authentication.js';
import './partner-scheduling-workbook-subscriptions.js';
import { initERM } from '@adornis/entity-relationship-management/init.js';

initERM({
  policies: [
    {
      name: '@nsc/nexus/erm',
      evaluate: () => {
        // ? we're currently handling access outside this
        return Promise.resolve({ allowed: true, reason: 'Nexus ERM policy' });
      },
    },
  ],
});
